export default __webpack_public_path__ + "static/media/Directory.f8b9a025.svg";